import React from 'react';
import { Section } from './ui/Section';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  return <Section data-id="element-23">
      <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-8 text-center" data-id="element-24">
        Lo que has intentado <br data-id="element-25" />
        <span className="text-base font-sans font-normal text-cream-100 opacity-80" data-id="element-26">
          (y por qué no te sirve a las 3AM)
        </span>
      </h2>

      <div className="space-y-6 text-lg text-cream-100" data-id="element-27">
        <p data-id="element-28">Tal vez ya intentaste:</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-29">
          {['acostarte más temprano', 'evitar café', 'té, melatonina, "gotitas"', 'ventilador, sábanas, mil ajustes', 'respirar "a ver si funciona"'].map((item, i) => <div key={i} className="flex items-center p-3 bg-warm-800/50 rounded-lg border border-warm-700" data-id="element-30">
              <XCircleIcon className="w-5 h-5 text-red-400 mr-3 flex-shrink-0" data-id="element-31" />
              <span data-id="element-32">{item}</span>
            </div>)}
        </div>

        <div className="bg-amber-900/20 p-6 rounded-xl border border-amber-500/30" data-id="element-33">
          <p className="font-bold text-amber-500 mb-2 text-xl" data-id="element-34">El problema:</p>
          <p className="mb-4" data-id="element-35">
            Todo eso es de las 9pm. Pero tú no necesitas consejos "bonitos".
          </p>
          <p className="mb-4" data-id="element-36">Tú necesitas un plan cuando:</p>
          <ul className="list-disc pl-5 space-y-2 mb-6" data-id="element-37">
            <li data-id="element-38">estás medio dormida</li>
            <li data-id="element-39">el cuerpo está incómodo</li>
            <li data-id="element-40">y la mente está buscando pelea</li>
          </ul>
          <p className="text-xl font-serif text-cream-50 text-center border-t border-amber-500/30 pt-4 mt-4" data-id="element-41">
            A las 3AM no se reflexiona.{' '}
            <span className="italic text-amber-500" data-id="element-42">Se ejecuta.</span>
          </p>
        </div>
      </div>
    </Section>;
}